<template>
  <div class="w-100 d-flex flex-column gap-4">
    <h4 data-testid="open-incidents-title" class="font-weight-bold">
      Open Incidents
    </h4>
    <v-item-group v-model="model" class="d-flex">
      <v-item v-for="priority in 3" :key="priority">
        <template #default="{ toggle }">
          <v-btn
            :data-testid="`open-incidents-priority-button-${priority}`"
            :class="getRoundedCorners(priority)"
            :active="model + 1 === priority"
            height="36"
            variant="outlined"
            width="33%"
            @click="toggle"
          >
            <span
              :data-testid="`open-incidents-priority-${priority}`"
              class="priority-button"
              >P{{ priority }}</span
            >
          </v-btn>
        </template>
      </v-item>
    </v-item-group>
    <div class="w-100">
      <v-progress-linear v-if="isLoading" indeterminate color="border" />
      <p
        v-if="!isLoading && (!openIssues || openIssues.length === 0)"
        data-testid="open-incidents-no-incidents"
        class="font-italic"
      >
        No Priority {{ model + 1 }} incidents ongoing
      </p>
      <OpenIncidentCard
        v-for="issue in pageItems"
        :key="issue.key"
        data-testid="open-incidents-card"
        :issue="issue"
      />
      <SoPagination
        v-show="openIssues?.length > 5"
        :key="openIssues?.length"
        v-model="pageItems"
        data-testid="open-incidents-pagination"
        :list="openIssues"
        :page-size="5"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import OpenIncidentCard from "@/views/bugsInfo/components/OpenIncidentCard.vue"
  import SoPagination from "@/components/SoPagination.vue"
  import { IJiraIssue } from "@/models/jiraIssue/jiraIssue.types"
  import { JiraIssuesService } from "@/services/JiraIssuesService"

  export default defineComponent({
    components: { SoPagination, OpenIncidentCard },
    data() {
      return {
        model: 0,
        issuesService: JiraIssuesService.getOpenJiraIssues,
        pageItems: [] as IJiraIssue[],
      }
    },
    computed: {
      fetchOpenIssues() {
        return this.issuesService({ priority: this.model + 1 })
      },
      openIssues() {
        return this.fetchOpenIssues?.data.issues
      },
      isLoading() {
        return this.fetchOpenIssues?.isFetching
      },
    },
    methods: {
      getRoundedCorners(item: number) {
        switch (item) {
          case 1:
            return "border-rounded-left"
          case 2:
            return "rounded-0"
          case 3:
            return "border-rounded-right"
          default:
            return "rounded-0"
        }
      },
    },
  })
</script>

<style scoped>
  .v-btn--active {
    background-color: rgb(var(--v-theme-success));
    font-weight: bold;
  }

  .border-rounded-left {
    border-radius: 6px 0 0 6px;
    border-right: none;
  }

  .border-rounded-right {
    border-radius: 0 6px 6px 0;
    border-left: none;
  }

  .priority-button {
    font-size: 14px;
    line-height: 133%;
  }
</style>
